<template>
  <router-link v-if="permittedRoute" :to="permittedRoute">
    <slot />
  </router-link>

  <span v-else>
    <slot />
  </span>
</template>

<script setup lang="ts">
import { useCanNavigateTo } from '@/hooks/useCanNavigateTo'
import type { RawLocation } from 'vue-router'
import { computed } from 'vue'

interface Props {
  /**
   * Target route. Pass `null` when the caller has nothing to link to — an
   * entity without an id, or a kind this build has no route for — and the
   * content renders as plain text.
   */
  to?: RawLocation | null
}

const props = withDefaults(defineProps<Props>(), { to: null })

const { canNavigateTo } = useCanNavigateTo()

const permittedRoute = computed(() =>
  props.to && canNavigateTo(props.to) ? props.to : null
)
</script>
